/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-02-16 19:58:17
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Icon } from '@shopify/polaris';
import { DragHandleMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import type { DropResult } from 'react-beautiful-dnd';

import RenderSelectProduct from 'src/components/containers/merchandising-v2/rule/strategy/pin-products/render-select-product';
import PinProductsTableCell from './pin-products-table-cell';

type Props = {
  pinPositions: Array<Object>,
  fields: Object
};

type ComposedProps = Props & WithI18nProps;

class PinsTable extends Component<ComposedProps> {
  onDragEnd = (result: DropResult) => {
    const { fields } = this.props;

    // dropped outside the list
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }

    // no movement
    if (result.destination.index === result.source.index) {
      return;
    }

    fields.move(result.source.index, result.destination.index);
  };

  render() {
    const { fields, pinPositions, i18n } = this.props;
    return (
      <div>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="Polaris-DataTable BC-DataTable__PinProducts">
            <div className="Polaris-DataTable__ScrollContainer" style={{ marginLeft: 0 }}>
              <table className="Polaris-DataTable__Table">
                <Droppable droppableId="table">
                  {provided => (
                    <tbody ref={provided.innerRef} {...provided.droppableProps}>
                      <tr className="Polaris-DataTable__TableRow">
                        {/* Drag icon */}
                        <td className="Polaris-DataTable__Cell Polaris-DataTable__Cell--firstColumn"></td>
                        <td className="Polaris-DataTable__Cell">
                          {i18n.translate(
                            'AdminHTML.MerchandisingV2.PinProductsModal.table_Position_Title'
                          )}
                        </td>
                        <td className="Polaris-DataTable__Cell">
                          {i18n.translate(
                            'AdminHTML.MerchandisingV2.PinProductsModal.table_Product_Title'
                          )}
                        </td>
                      </tr>
                      {fields.map((item, key) => {
                        const { id = 'id' } = pinPositions[key];

                        return (
                          // Enable drag for per option row
                          <Draggable draggableId={`${id}-${key}`} key={`${id}-${key}`} index={key}>
                            {(provided, snapshot) => (
                              <tr
                                className="Polaris-DataTable__TableRow"
                                ref={provided.innerRef}
                                {...provided.dragHandleProps}
                                {...provided.draggableProps}>
                                {/* Drag icon */}
                                <PinProductsTableCell
                                  isDragOccurring={snapshot.isDragging}
                                  className="Polaris-DataTable__Cell Polaris-DataTable__Cell--firstColumn">
                                  <Icon color="base" source={DragHandleMinor} />
                                </PinProductsTableCell>

                                {/* Position */}
                                <PinProductsTableCell
                                  isDragOccurring={snapshot.isDragging}
                                  className="Polaris-DataTable__Cell">
                                  <div className="position-number">{key + 1}</div>
                                </PinProductsTableCell>

                                {/* Product */}
                                <PinProductsTableCell
                                  isDragOccurring={snapshot.isDragging}
                                  className="Polaris-DataTable__Cell">
                                  <Field name={`${item}.id`} component={RenderSelectProduct} />
                                </PinProductsTableCell>
                              </tr>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </tbody>
                  )}
                </Droppable>
              </table>
            </div>
          </div>
        </DragDropContext>
      </div>
    );
  }
}
export default withI18n()(PinsTable);
